import React from 'react';

const DataBreach = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        In case of a data breach:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>Immediate notification to affected users</li>
        <li>Thorough investigation of the incident</li>
        <li>Implementation of necessary security measures</li>
        <li>Cooperation with relevant authorities</li>
      </ul>
    </div>
  );
};

export default DataBreach;